import { getBsaApiUrl, isBsaProdForced } from '../helpers/bsaConfig';

const ODD_PORTAL_PROD_URL = 'https://www.findbugzero.com';
const ODD_PORTAL_DEV_URL = 'https://dev-odd.findbugzero.com';

export default {
  get api() {
    const url = getBsaApiUrl();
    console.log('ODD API URL resolved to:', url);
    return url;
  },
  get portalUrl() {
    return isBsaProdForced() ? ODD_PORTAL_PROD_URL : ODD_PORTAL_DEV_URL;
  }
};
